var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"step-option-radio",class:{ 'is-checked': _vm.checked }})}
var staticRenderFns = []

export { render, staticRenderFns }